// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SisternodeOutlinedSvg from "@ant-design/icons-svg/es/asn/SisternodeOutlined";
import AntdIcon from '../components/AntdIcon';

var SisternodeOutlined = function SisternodeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SisternodeOutlinedSvg
  }));
};

SisternodeOutlined.displayName = 'SisternodeOutlined';
export default React.forwardRef(SisternodeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SisternodeOutlined.js
// module id = 1803
// module chunks = 0